// extracted by mini-css-extract-plugin
module.exports = {"jumbotron":"jumbotron__LN_bP","stripes":"stripes__2VBNF","content":"content__2cBQ-"};